import { gql } from '@apollo/client'
import { graphql } from 'gql/generated'

export const GET_BUSINESS_CLIENT_USERS = graphql(`
  query GetBusinessClientUsers($input: BusinessClientUsersInput!, $pagination: PaginationV2) {
    businessClientUsers(input: $input, pagination: $pagination) {
      total
      items {
        id
        isActive
        title
        hasAdminRole
        createdAt
        updatedAt
        userAccount {
          id
          firstName
          lastName
          phoneNumber {
            countryCode
            number
          }
          email
        }
        businessClient {
          id
          name
        }
        businessSite {
          id
          name
        }
      }
    }
  }
`)

export const GET_BUSINESS_CLIENT_USER = gql(`
  query GetBusinessClientUser($id: UUID!) {
    businessClientUser(id: $id) {
      id
      isActive
      hasAdminRole
      title
      createdAt
      updatedAt
      userAccount {
        id
        firstName
        lastName
        phoneNumber {
          countryCode
          number
        }
        email
      }
      businessClient {
        id
        name
      }
      businessSite {
        id
        name
      }
    }
  }
`)
